import React, { useEffect } from "react";
import NavBar from "../layouts/NavBar";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact";
  }, []);

  return (
    <>
      <NavBar />
      <h1 className="display-4 text-center">Contact Us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aperiam fugit
        deserunt possimus perferendis sapiente eum quidem, nesciunt nisi
        molestias delectus consequatur veniam accusantium quod facilis corporis
        in animi repudiandae! Quas. Lorem ipsum dolor, sit amet consectetur
        adipisicing elit. Voluptas quam quibusdam iure natus corrupti minus
        earum aperiam nemo qui? Vero obcaecati nemo incidunt, repellendus unde
        hic. Placeat officiis rem perspiciatis. Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Corporis nam eum molestiae totam.
        Voluptatem, tempora voluptates harum voluptatum ratione tempore qui at
        nesciunt non quaerat repudiandae dignissimos eum, consectetur aliquid.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deleniti, ad,
        architecto sapiente incidunt commodi natus, sit id dolores omnis
        doloribus aliquam nobis iusto porro quae ipsa et odit suscipit vel!
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat,
        dolore. Modi magnam facere dolores doloremque veniam sed deserunt,
        possimus accusantium molestias tempora? Numquam sed eaque commodi
        molestiae ad, delectus laborum. Lorem ipsum dolor sit, amet consectetur
        adipisicing elit. Facilis quia, deserunt illum magni vitae fuga
        voluptate et, nihil mollitia perspiciatis vero? Est, laborum ab fugit
        soluta aut perspiciatis repellat sapiente? Lorem ipsum dolor, sit amet
        consectetur adipisicing elit. Dolorum nemo voluptate corrupti debitis
        quod sunt laudantium magni accusamus reprehenderit cum laborum quibusdam
        expedita animi et, ab aut quia, obcaecati ad.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestiae,
        facere accusantium sed officia laboriosam eius porro voluptas temporibus
        quae fugiat fuga rem. Earum nulla amet cumque, vero animi magni
        architecto. Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Libero nostrum quis modi dicta eius est, omnis perferendis odio
        perspiciatis facere non adipisci minus ex laudantium! Explicabo,
        mollitia. At, aut? Quasi? Lorem ipsum dolor sit amet consectetur,
        adipisicing elit. Accusamus voluptate, magni, dolores delectus
        aspernatur error sequi voluptas sapiente velit nulla cum. Cum
        repellendus a nisi suscipit tempore iste quasi quo! Lorem ipsum dolor,
        sit amet consectetur adipisicing elit. Dolores ducimus placeat,
        repellendus vero at fuga explicabo voluptates possimus tempore ipsum.
        Ipsam possimus neque quo consectetur ipsum commodi voluptas ut optio!
      </p>
      <p>Thank you for visiting our site</p>
    </>
  );
};

export default Contact;
